import { useIntersect, useScroll, useTexture, Text, createInstances, Float, Sparkles, PresentationControls, Center, Image } from "@react-three/drei"
import { mainStore } from "../../store"
import { useFrame, useThree } from "@react-three/fiber"

import { Suspense, useEffect, useMemo, useRef } from "react"
import { __ } from "../../utils"
import * as THREE from 'three'




import Team from "../../components/team.jsx"


import TextRight from "../../components/textRight.jsx"
import TextLeft from "../../components/textLeft.jsx"
import TextCenter from "../../components/textCenter.jsx"
import TestVivo from "../../components/image/TestVivo.jsx"
import { WorldMap } from "../../components/models/world/model.jsx"
import AtelierProductionUP2 from "../../components/image/AtelierProductionUP2.jsx"
import Bouquet from "../../components/image/Bouquet.jsx"
import { Autophagy } from "../../components/models/autophagy/model.jsx"
import Fondation from "../../components/image/Fondation.jsx"
import CDR from "../../components/image/CDR.jsx"
import Avoine from "../../components/image/Avoine.jsx"
import Silabskin from "../../components/image/Silabskin.jsx"


export default function BodyChapterThree() {
    // Utils
    const data = useScroll()
    const { width, height } = useThree((state) => state.viewport)


    // Store
    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)
    const scrollMap = mainStore.useStore(s => s.scrollMap)
    const currentChapter = mainStore.useStore((s) => s.current)
    const isUiHidden = mainStore.useStore((s) => s.isUiHidden)
    const preventChapterUpdate = mainStore.useStore(s => s.preventChapterUpdate)

    const lang = mainStore.useStore(s => s.lang)


        
    const chapters = mainStore.useStore(s => s.chapters)
    const chapter = chapters[2]


    // Refs
    const worldRef = useRef()

    /**
     * Shaders
     * */



    useFrame(({ clock }) => {

        worldRef.current.rotation.y = clock.getElapsedTime() * 0.1

        // Chapter auto selector
        // if (data.scroll.current > scrollMap.one && data.scroll.current <= scrollMap.two && !currentChapter.dates.includes(1991) && isUiHidden && !preventChapterUpdate) {
        //     mainStore.selectChapter('UNICITÉ', [1990, 1999])
        // }

        if (data.scroll.current > chapter.start && data.scroll.current <= scrollMap.three) {

            if(!currentChapter.dates.includes(2000) || !currentChapter.dates.includes(2010))
            {
                mainStore.preventChapterUpdate(true)
                mainStore.selectChapter(chapter.name[lang === 'fr' ? lang : 'en'], chapter.dates, chapter.start)
                setTimeout(() => mainStore.preventChapterUpdate(false), 1000)

            }
        }
    })




    return <>
        <group position={[0, -43, 0]}>

            <group position={[0, -0.9, 0]}>

                {
                    __(
                        //FR
                        <>
                            <TextLeft
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.2}
                                scale={1}
                                exposant={"res"}
                                offsetX={0.88}
                                offsetY={-0.2}>
                                Création des 1   filiales
                            </TextLeft>

                            <TextLeft
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.4}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.4}>
                                SILAB Inc. aux États-Unis & SILAB South Korea en Corée du Sud assurent la promotion et la distribution de toute la gamme d’actifs sur leurs territoires respectifs.
                            </TextLeft>
                        </>,
                        // EN
                        <>
                            <TextLeft
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.2}
                                scale={1}
                                exposant={"st"}
                                offsetX={1.04}
                                offsetY={-0.2}>
                                Creation of the 1  subsidiaries
                            </TextLeft>

                            <TextLeft
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.4}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.4}>
                                SILAB Inc. in the United States & SILAB South Korea promote and distribute the full range of active ingredients in their respective territories.
                            </TextLeft>
                        </>
                    )
                }


            </group>
            <group position={[0, -1, 0]} >
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={.3}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2003
                </TextLeft>
                <WorldMap position={[2.7, 0.1, 0]} ref={worldRef} scale={1} />
            </group>
            <group position={[0, -2, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={.0}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2004
                </TextLeft>
                {
                    __(
                        //FR
                        <>
                            <TextLeft
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.4}
                                scale={1}
                                exposant={"re"}
                                offsetX={0.05}
                                offsetY={-0.4}>
                                1   édition « SILAB’s Days »
                            </TextLeft>
                            <TextLeft
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.6}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.6}>
                                Ces journées spéciales et conviviales permettent de réunir clients et partenaires sur le site de SILAB, pour échanger sur les avancées scientifiques du secteur.
                            </TextLeft>
                        </>,
                        //EN
                        <>
                            <TextLeft
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.4}
                                scale={1}
                                exposant={"st"}
                                offsetX={0.05}
                                offsetY={-0.4}>
                                1  "SILAB's Days"
                            </TextLeft>
                            <TextLeft
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.6}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.6}>
                                These special and friendly days bring customers and partners together on the SILAB site to discuss scientific advances in the sector.
                            </TextLeft>
                        </>
                    )
                }

            </group>
            <group position={[0, -4, 0]}>
                <AtelierProductionUP2 position={[-3, -0.5, 0]} scale={1.2} />
                {
                    __(
                        //FR
                        <>
                            <TextRight
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.4}
                                scale={1}
                                exposant={"e"}
                                offsetX={-1.39}
                                offsetY={-0.27}>
                                2  atelier de production
                            </TextRight>
                            <TextRight
                                maxWidth={1.4}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.65}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.6}>
                                Sa spécificité est de fournir un outil high-tech automatisé à grande capacité.
                            </TextRight>
                        </>,
                        //EN
                        <>
                            <TextRight
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.4}
                                scale={1}
                                exposant={"nd"}
                                offsetX={-1.1}
                                offsetY={-0.28}>
                                2   production unit
                            </TextRight>
                            <TextRight
                                maxWidth={1.4}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.65}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.6}>
                                What makes it special is that it provides a high-tech, high-capacity automated tool.
                            </TextRight>
                        </>
                    )
                }

                <Team scale={0.6} offsetNumber={-0.09} position={[width * 0.23 - 1.2, -0.2, 2]}>
                    100
                </Team>

            </group>
            <group position={[0, -6.5, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={.0}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2005
                </TextLeft>
                {
                    __(
                        //FR
                        <>
                            <TextLeft
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.4}
                                scale={1}
                                exposant={"er"}
                                offsetX={0.05}
                                offsetY={-0.4}>
                                1  actif lancé à base de fleurs
                            </TextLeft>
                            <TextLeft
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.6}
                                scale={1}
                                exposant={"®"}
                                offsetX={0.47}
                                offsetY={-0.6}>
                                AQUAPHYLINE   , issu de pensée sauvage, est recommandé pour les programmes d’hydratation intense et de lutte contre les peaux sèches.
                            </TextLeft>
                        </>,
                        //EN
                        <>
                            <TextLeft
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.4}
                                scale={1}
                                exposant={"st"}
                                offsetX={0.05}
                                offsetY={-0.4}>
                                1  flower-based active ingredient launched
                            </TextLeft>
                            <TextLeft
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.6}
                                scale={1}
                                exposant={"®"}
                                offsetX={0.475}
                                offsetY={-0.6}>
                                AQUAPHYLINE   , derived from wild pansy, is recommended for intense hydration program and to fight against skin dryness.
                            </TextLeft>
                        </>
                    )
                }
                {
                    __(
                        //FR
                        <>
                            <TextLeft
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-1.2}
                                scale={1}
                                exposant={"res"}
                                offsetX={0.05}
                                offsetY={-1.2}>
                                1   « Journées Familles »
                            </TextLeft>
                            <TextLeft
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-1.4}
                                scale={1}

                                offsetX={0.429}
                                offsetY={-0.6}>
                                SILAB ouvre ses portes pour faire visiter son site aux familles des collaborateurs.
                            </TextLeft>
                        </>,
                        //EN
                        <>
                            <TextLeft
                                maxWidth={4}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-1.2}
                                scale={1}
                                exposant={"st"}
                                offsetX={0.05}
                                offsetY={-1.2}>
                                1  “Family Days”
                            </TextLeft>
                            <TextLeft
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-1.4}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.6}>
                                SILAB opens its doors to allow collaborators’ families to visit its site.
                            </TextLeft>
                        </>
                    )
                }
                <Bouquet position={[0, -0.9, 0]} />
            </group>
            <group position={[0, -9, 0]}>
                {/* <PresentationControls
                    config={{ mass: 2, tension: 500 }}
                    snap={{ mass: 4, tension: 100 }}
                    rotation={[-0.4, 0.3, 0]}
                    polar={[-Math.PI / 3, Math.PI / 3]}
                    azimuth={[-Math.PI / 2.4, Math.PI / 4]}
                > */}
                <Float speed={0.2}>

                    <Autophagy scale={0.6} rotation={[0.6, Math.PI * 0.73, 0.1]} position={[-1.4, -2, 1]} />

                </Float>
                {/* </PresentationControls> */}
                {/* <Image
                    url={import.meta.env.BASE_URL + "static/icons/rotate.svg"}
                    scale={.5}
                    zoom={1}
                    opacity={0.7}
                    position={[-0.7, -2.9, -0.3]}
                    transparent
                /> */}
                <group position={[0, -1, 0]}>
                    <TextRight
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.26}
                        positionY={0}
                        // positionX={-0.09}
                        // positionZ={1.2}
                        fontsOw={fonts.ms.title}
                    >
                        2006
                    </TextRight>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={1.7}
                                    fontsOw={fonts.cm.title}
                                    lineHeight={1}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-1.39}
                                    offsetY={-0.27}>
                                    Programme de recherche sur l’autophagie
                                </TextRight>
                                <TextRight
                                    maxWidth={1.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.8}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.6}>
                                    Pour la première fois en Recherche fondamentale sur des cellules primaires humaines saines, SILAB démontre qu’une activité autophagique existe dans la peau.
                                </TextRight>
                            </>,
                            //EN
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.3}
                                    scale={1}
                                    offsetX={-1.1}
                                    offsetY={-0.28}>
                                    Autophagy research program
                                </TextRight>
                                <TextRight
                                    maxWidth={1.7}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.65}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.6}>
                                    For the first time in fundamental Research on healthy human primary cells, SILAB demonstrates that autophagic activity exists in the skin.
                                </TextRight>
                            </>
                        )
                    }
                </group>
                {/* <group position={[0, -2, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={1.6}
                                    fontsOw={fonts.cm.title}
                                    lineHeight={1}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-1.39}
                                    offsetY={-0.27}>
                                    Participation active au sein de Ingrecos
                                </TextRight>
                                <TextRight
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.75}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.6}>
                                    SILAB débute son implication avec le syndicat professionnel Ingrecos (anciennement Aspa-Ingrecos) avec une place au sein du conseil d’administration.
                                </TextRight>
                            </>,
                            //EN
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.3}
                                    scale={1}
                                    offsetX={-1.1}
                                    offsetY={-0.28}>
                                    Active participation in Ingrecos
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.55}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.6}>
                                    SILAB begins its involvement with the Ingrecos trade association (previously Aspa-Ingrecos) with a seat on the board of directors.
                                </TextRight>
                            </>
                        )
                    }
                </group> */}
                <group position={[0, -2, 0]}>
                    <TextRight
                        maxWidth={4.2}
                        fontSize={0.26}
                        positionY={-.2}
                        positionZ={0}
                        fontsOw={fonts.ms.title}
                        depthWrite={false}
                    >
                        2007
                    </TextRight>
                    <group position={[0, 0, 0]}>
                        {
                            __(
                                //FR
                                <>
                                    <TextRight
                                        maxWidth={width * 0.8 / 2}
                                        fontsOw={fonts.cm.title}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        positionY={-0.6}
                                        scale={1}
                                        exposant={"re"}
                                        offsetX={-0.81}
                                        offsetY={-0.47}>
                                        1   charte RSE
                                    </TextRight>
                                    <TextRight
                                        maxWidth={width * 0.8 / 4}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-0.8}
                                        scale={1}

                                        offsetX={0.429}
                                        offsetY={-0.9}>
                                        Pour la première fois, SILAB formalise son engagement RSE à travers une charte dédiée et un plan d’actions.
                                    </TextRight>
                                </>,
                                //EN
                                <>
                                    <TextRight
                                        maxWidth={width * 0.8 / 2}
                                        fontsOw={fonts.cm.title}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        positionY={-0.6}
                                        scale={1}
                                        exposant={"st"}
                                        offsetX={-0.89}
                                        offsetY={-0.47}>
                                        1   CSR charter
                                    </TextRight>
                                    <TextRight
                                        maxWidth={width * 0.8 / 4}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-0.8}
                                        scale={1}

                                        offsetX={0.429}
                                        offsetY={-0.9}>
                                        For the first time, SILAB is formalizing its CSR commitment through a dedicated charter and action plan.
                                    </TextRight>
                                </>
                            )
                        }
                        

                    </group>
                    <group position={[0, -0.4, 0]}>
                    {
                            __(
                                //FR
                                <>
                                    <TextRight
                                        maxWidth={width * 0.8 / 4}
                                        fontsOw={fonts.cm.title}
                                        lineHeight={1}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        positionY={-0.72}
                                        scale={1}
                                        offsetX={-1.39}
                                        offsetY={-0.27}>
                                        Création de SILAB China
                                    </TextRight>
                                    <TextRight
                                        maxWidth={width * 0.8 / 4}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-.87}
                                        scale={1}
                                        offsetX={-0.43}
                                        offsetY={-0.6}>
                                        avec l’ouverture d’un bureau de représentation à Shanghai.
                                    </TextRight>
                                </>,
                                //EN
                                <>
                                    <TextRight
                                        maxWidth={width * 0.8 / 4}
                                        fontsOw={fonts.cm.title}
                                        lineHeight={1}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        positionY={-0.72}
                                        scale={1}
                                        offsetX={-1.39}
                                        offsetY={-0.27}>
                                        Creation of SILAB China
                                    </TextRight>
                                    <TextRight
                                        maxWidth={width * 0.8 / 4}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-.87}
                                        scale={1}
                                        offsetX={-0.43}
                                        offsetY={-0.6}>
                                        with the opening of a representative office in Shanghai.
                                    </TextRight>
                                </>
                            )
                        }
                    </group>
                </group>
                <group position={[0, -4.3, 0]}>
                    <TextLeft
                        maxWidth={4.2}
                        fontSize={0.26}
                        positionY={-.6}
                        positionZ={0}
                        fontsOw={fonts.ms.title}
                        depthWrite={false}
                    >
                        2008
                    </TextLeft>
                    <Fondation scale={1.4} position={[-.9, -1.4, 0]} />
                    <group position={[0, -.4, 0]}>
                        {
                            __(
                                //FR
                                <>
                                    <TextLeft
                                        maxWidth={2}
                                        fontsOw={fonts.cm.title}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        lineHeight={1}
                                        positionY={-0.6}
                                        scale={1}
                                        exposant={"er"}
                                        offsetX={0.05}
                                        offsetY={-0.6}>
                                        1   lauréat de la Fondation d’Entreprise SILAB - Jean PAUFIQUE
                                    </TextLeft>
                                    <TextLeft
                                        maxWidth={2}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-1.15}
                                        scale={1}

                                        offsetX={0.429}
                                        offsetY={-0.9}>
                                        Créée en 2007, la Fondation alloue une Aide à la Recherche pour soutenir des jeunes chercheurs dans le domaine des pathologies cutanées.
                                    </TextLeft>
                                </>,
                                //EN
                                <>
                                    <TextLeft
                                        maxWidth={2}
                                        fontsOw={fonts.cm.title}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        lineHeight={1}
                                        positionY={-0.6}
                                        scale={1}
                                        exposant={"st"}
                                        offsetX={0.05}
                                        offsetY={-0.6}>
                                        1   prizewinner of the SILAB - Jean PAUFIQUE Corporate Foundation
                                    </TextLeft>
                                    <TextLeft
                                        maxWidth={2}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-1.15}
                                        scale={1}

                                        offsetX={0.429}
                                        offsetY={-0.9}>
                                        Created in 2007, the Foundation provides Research grants to support young researchers in the field of skin pathologies.
                                    </TextLeft>
                                </>
                            )
                        }
                    </group>

                </group>
                <group position={[0, -7.4, 0]}>
                    <CDR scale={1.3} position={[-3.3, -0.7, 0]} />
                    <group>
                        {
                            __(
                                //FR
                                <>
                                    <TextRight
                                        maxWidth={3}
                                        fontsOw={fonts.cm.title}
                                        lineHeight={1}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        positionY={-.4}
                                        scale={1}
                                        offsetX={-1.39}
                                        offsetY={-0.27}>
                                        Nouveau Centre de recherche
                                    </TextRight>
                                    <TextRight
                                        maxWidth={2.2}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-.65}
                                        scale={1}
                                        offsetX={-0.43}
                                        offsetY={-0.6}>
                                        de 3 500 m² regroupant des équipements et technologies ultramodernes.
                                    </TextRight>
                                </>,
                                //EN
                                <>
                                    <TextRight
                                        maxWidth={3}
                                        fontsOw={fonts.cm.title}
                                        lineHeight={1}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        positionY={-.4}
                                        scale={1}
                                        offsetX={-1.39}
                                        offsetY={-0.27}>
                                        New Research center
                                    </TextRight>
                                    <TextRight
                                        maxWidth={1.5}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-.65}
                                        scale={1}
                                        offsetX={-0.43}
                                        offsetY={-0.6}>
                                        of 3,500 m² combining cutting-edge equipment and technologies.
                                    </TextRight>
                                </>
                            )
                        }
                    </group>
                    <group position={[0, -0.8, 0]}>
                        {
                            __(
                                //FR
                                <>
                                    <TextRight
                                        maxWidth={3}
                                        fontsOw={fonts.cm.title}
                                        lineHeight={1}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        positionY={-.4}
                                        scale={1}
                                        offsetX={-1.39}
                                        offsetY={-0.27}>
                                        Intégration des technologies OMICS
                                    </TextRight>
                                    <TextRight
                                        maxWidth={2.4}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-.65}
                                        scale={1}
                                        offsetX={-0.43}
                                        offsetY={-0.6}>
                                        au cœur de la Recherche SILAB. Ces technologies avancées permettront à SILAB de modéliser et démontrer les mécanismes cutanés.
                                    </TextRight>
                                </>,
                                //EN
                                <>
                                    <TextRight
                                        maxWidth={3}
                                        fontsOw={fonts.cm.title}
                                        lineHeight={1}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        positionY={-.4}
                                        scale={1}
                                        offsetX={-1.39}
                                        offsetY={-0.27}>
                                        Integration of OMICS technologies
                                    </TextRight>
                                    <TextRight
                                        maxWidth={2.4}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-.65}
                                        scale={1}
                                        offsetX={-0.43}
                                        offsetY={-0.6}>
                                        at the core of SILAB's Research. These advanced technologies will enable SILAB to model and demonstrate cutaneous mechanisms.
                                    </TextRight>
                                </>
                            )
                        }
                    </group>
                </group>
                <group position={[0, -11, 0]}>
                    <Avoine position={[0, 0.4, 0]} />
                    <group position={[0, 1, 0]}>
                        {
                            __(
                                //FR
                                <>
                                    <TextLeft
                                        maxWidth={2}
                                        fontsOw={fonts.cm.title}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        lineHeight={1}
                                        positionY={-0.6}
                                        scale={1}
                                        exposant={"er"}
                                        offsetX={0.05}
                                        offsetY={-0.6}>
                                        1   actif certifié biologique
                                    </TextLeft>
                                    <TextLeft
                                        maxWidth={2}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.038}
                                        positionY={-0.85}
                                        scale={1}
                                        exposant={["®", "www.cosmos-standard.org/fr/cosmos-standard"]}
                                        expFont={fonts.ms.italic}
                                        expOffsetArray={[
                                            [0.629, -0.85],
                                            [0.0, -1.05]
                                        ]}>
                                        SILAB lance OSILIFT    BIO, son premier actif de la gamme certifiée par ECOCERT Greenlife selon le référentiel COSMOS.
                                    </TextLeft>
                                </>,
                                //EN
                                <>
                                    <TextLeft
                                        maxWidth={2.5}
                                        fontsOw={fonts.cm.title}
                                        fontSize={0.16}
                                        exposantHeight={0.07}
                                        lineHeight={1}
                                        positionY={-0.6}
                                        scale={1}
                                        exposant={"st"}
                                        offsetX={0.05}
                                        offsetY={-0.6}>
                                        1   organic-certified active ingredient
                                    </TextLeft>
                                    <TextLeft
                                        maxWidth={2}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.038}
                                        positionY={-0.85}
                                        scale={1}
                                        exposant={["®", "www.cosmos-standard.org/en/cosmos-standard"]}
                                        expFont={fonts.ms.italic}
                                        expOffsetArray={[
                                            [0.84, -0.85],
                                            [0.0, -1.15]
                                        ]}>
                                        SILAB is launching OSILIFT    BIO, its first active ingredient in the range certified by ECOCERT Greenlife in accordance with the COSMOS standards.
                                    </TextLeft>
                                </>
                            )
                        }
                    </group>
                </group>
                <group position={[0, -12.5, 0]}>
                    <TextRight
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.26}
                        positionY={0}
                        // positionX={-0.09}
                        // positionZ={1.2}
                        fontsOw={fonts.ms.title}
                    >
                        2009
                    </TextRight>
                    <Silabskin scale={1.3} position={[-3.5, 0, 0]} />
                    <group position={[0, -0.1, 0]}>
                        {
                            __(
                                //FR
                                <>
                                    <TextRight
                                        maxWidth={2}
                                        fontsOw={fonts.cm.title}
                                        lineHeight={1}
                                        fontSize={0.16}
                                        exposantHeight={0.09}
                                        positionY={-.4}
                                        exposant={"®"}
                                        scale={1}
                                        offsetX={-.92}
                                        offsetY={-0.08}>
                                        SILABSKIN   : expertise en ingénierie tissulaire
                                    </TextRight>
                                    <TextRight
                                        maxWidth={2.2}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-.75}
                                        scale={1}
                                        offsetX={-0.43}
                                        offsetY={-0.6}>
                                        Modèles 3D d’épidermes reconstruits ou de peaux reconstruites, développés par les équipes de Recherche SILAB pour appréhender les mécanismes d’actions et démontrer l’efficacité.
                                    </TextRight>
                                </>,
                                //EN
                                <>
                                    <TextRight
                                        maxWidth={2}
                                        fontsOw={fonts.cm.title}
                                        lineHeight={1}
                                        fontSize={0.16}
                                        exposantHeight={0.09}
                                        positionY={-.4}
                                        exposant={"®"}
                                        scale={1}
                                        offsetX={-.86}
                                        offsetY={-0.08}>
                                        SILABSKIN  : expertise in tissue engineering
                                    </TextRight>
                                    <TextRight
                                        maxWidth={2.2}
                                        fontsOw={fonts.ms.text}
                                        fontSize={0.062}
                                        lineHeight={1.4}
                                        exposantHeight={0.05}
                                        positionY={-.75}
                                        scale={1}
                                        offsetX={-0.43}
                                        offsetY={-0.6}>
                                        3D models of reconstructed epidermis or reconstructed skin, developed by the SILAB Research teams to understand the mechanisms of action and demonstrate efficacy.
                                    </TextRight>
                                </>
                            )
                        }
                    </group>
                </group>
            </group>

        </group>

    </>
}